var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-wrapper"},[_c('ul',{staticClass:"marquee-vertical"},_vm._l((_vm.getMarquee),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":item.hyperlink,"target":item.target,"title":item.message}},[_vm._v(" "+_vm._s(item.message)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }